{
  "filterButtonText": "Find...",
  "sortLabel": "Sorting",
  "resetButtonText": "Reset",
  "showButtonText": "Show {0} results",
  "filterOverviewTitle": "Find...",
  "searchPlaceholder": "Search the list",
  "searchClearButtonAriaLabel": "Reset",
  "searchButtonAriaLabel": "Search"
}
